import { Box, Image, Text } from '@chakra-ui/react';
import { FormikProps } from 'formik';

import { Checkmark, HandWithKey } from '../../../assets/Images';
import ButtonedRadioGroup from '../../../components/ButtonedRadioGroup';
import { KeepMyCarFormValues } from './KeepMyCarPanel';

const KeepMyCarSelector = ({
  values,
  setFieldValue,
}: {
  values: KeepMyCarFormValues;
  setFieldValue: FormikProps<KeepMyCarFormValues>['setFieldValue'];
}) => {
  return (
    <Box w="100%" my={3}>
      <ButtonedRadioGroup
        mt={2}
        px={10}
        name="wants_to_sell"
        value={values.wants_to_sell}
        defaultValue="false"
        onChange={(value) => setFieldValue('wants_to_sell', value)}
        columns={1}
        spacing={4}
        options={[
          {
            label: (
              <>
                <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>
                  KEEP MY CAR
                </Text>
                <Text fontSize={{ base: 'sm', md: 'md' }}>Let’s get you a loan!</Text>
              </>
            ),
            value: 'false',
            selectedImage: (
              <Image
                zIndex={4}
                boxSize="60px"
                src={HandWithKey}
                alt="HandWithKey"
                position="absolute"
                left={-8}
                top="50%"
                transform="translateY(-50%)"
              />
            ),
          },
          {
            label: (
              <>
                <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>
                  SELL MY CAR
                </Text>
                <Text fontSize={{ base: 'sm', md: 'md' }}>
                  Buyers nationwide will compete for it
                </Text>
              </>
            ),
            value: 'true',
            selectedImage: (
              <Image
                zIndex={4}
                boxSize="40px"
                src={Checkmark}
                alt="Checkmark"
                position="absolute"
                left={-6}
                top="50%"
                transform="translateY(-50%)"
              />
            ),
          },
        ]}
      />
    </Box>
  );
};

export default KeepMyCarSelector;
